import { render, staticRenderFns } from "./LifefileOrderRxDetails.vue?vue&type=template&id=6d4121f1&scoped=true"
import script from "./LifefileOrderRxDetails.vue?vue&type=script&lang=js"
export * from "./LifefileOrderRxDetails.vue?vue&type=script&lang=js"
import style0 from "./LifefileOrderRxDetails.vue?vue&type=style&index=0&id=6d4121f1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4121f1",
  null
  
)

export default component.exports